module.exports = __webpack_public_path__ + "static/media/avatarIcon2.ef8a7cd0.png";